var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x80\x8F\x85",
    d: "M2.15186 11.9854C0.749023 11.9854 0 11.249 0 9.85254V2.14648C0 0.75 0.749023 0.0136719 2.15186 0.0136719H12.9365C14.3394 0.0136719 15.0884 0.756348 15.0884 2.14648V9.85254C15.0884 11.2427 14.3394 11.9854 12.9365 11.9854H2.15186ZM1.41553 2.29248V8.91309L3.05957 7.44678C3.32617 7.21191 3.58008 7.09131 3.87842 7.09131C4.17676 7.09131 4.46875 7.21826 4.73535 7.45312L5.90332 8.50684L8.76611 5.94873C9.05811 5.69482 9.36914 5.57422 9.71826 5.57422C10.0547 5.57422 10.3848 5.70752 10.6641 5.95508L13.6729 8.77344V2.29248C13.6729 1.7085 13.3682 1.4292 12.8159 1.4292H2.27246C1.71387 1.4292 1.41553 1.7085 1.41553 2.29248ZM5.05908 6.1582C4.2085 6.1582 3.5166 5.46631 3.5166 4.61572C3.5166 3.77148 4.2085 3.06689 5.05908 3.06689C5.90332 3.06689 6.59521 3.77148 6.59521 4.61572C6.59521 5.46631 5.90332 6.1582 5.05908 6.1582Z",
    fill: "#5046B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.80b26e27.svg";
export { ForwardRef as ReactComponent };